import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import WhyUs from "@/components/landing/WhyUs";
import Process from "@/components/landing/Process";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#F7F8F5]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyUs />
      <Process />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
